<template>
    <div class="header">
  
      <div class="container33 theme-showcase" v-if="(topimg != '' && topimg != null)">
        <img :src="topimg" style="max-width: 100%; display:block; margin:0 auto;" :style="topimgWidth==0?'width:100%;':('width:'+topimgWidth+'px;')"/>
      </div>

      <div style="display:flex; text-align:center; background:#cce6ff; margin:12px auto; " :style="'max-width:100%; width:'+FormWidth+'px;'">
      <div style="flex:1; padding:2px 0; ">1.Registration Profile</div>
      <div style="flex:1;  padding:2px 0; color:#fff; background:#23468c;">2.Payment</div>
      <div style="flex:1;  padding:2px 0; ">3.Confirmation</div>
    </div>
  
      <div class="container11 theme-showcase" :style="'max-width:100%; width:'+FormWidth+'px; min-height: 200px'">
  
        <div>
            <div style="font-weight: bold; margin: 12px 2vw; margin-bottom: 12px;">Select Forum <i @click="showRate" class="el-icon-info"></i></div>
            <div class="selectbox">
            <el-select  
        v-model="meetingid"
        @change="selectchange"
        multiple
        collapse-tags
        style=" width: 100%;"
        placeholder="Select">
        <el-option
          v-for="item in meetinglist"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>

    <div v-if="meetingid!=''">
    <div class="tablebox">

        <el-table
      :data="tableData"
      size="mini" ref="mytable"
      @row-click="rowClick"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="First Name">
      </el-table-column>
      <el-table-column
        prop="lname"
        label="Last Name">
      </el-table-column>
      <el-table-column
        prop="email"
        label="Email">
      </el-table-column>
      <el-table-column
        prop="tel"
        label="Tel">
      </el-table-column>
      <el-table-column
        prop="package"
        label="Package">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="amount">
      </el-table-column>

      <el-table-column label="Del" width="50">
      <template slot-scope="scope">
        <div v-if="scope.$index!=0">
            <i class="el-icon-delete" style="cursor: pointer;" @click.stop="handleDelete(scope.$index, scope.row)"></i>
        </div>
      </template>
      </el-table-column>

    </el-table>

    <div style="display: flex;">
    <div style="margin:8px; flex:1;">
        <el-button  icon="el-icon-plus" size="mini" v-if="cateType=='group'" @click="add">Add</el-button>
    </div>
    <div style="text-align: center; margin: 12px;">
<div style="margin:4px 0; font-size: 14px;">8% GST SGD {{GstAmount}}</div>
<div style="margin:4px 0; font-size: 14px;" v-if="promoAmount>0">Promo code:-{{promoAmount}}</div>
<div style="font-size: 22px;">Grand Total SGD {{ total-promoAmount +GstAmount }}</div>
    </div>
    </div>
    </div>

    <div class="tablebox" style="background-color: #fff;">
      <div style="color:red; margin-bottom:4px;">Enter promo code if any!</div>
      <div style="display: flex; ">
        <div>
  <el-input v-model="promocode" placeholder="PROMO CODE" size="mini"></el-input>
</div>
<div style="margin-left: 4px;">
  <el-button type="primary" size="mini" @click="applyPromo">Apply</el-button>
</div>
      </div>
      <div v-if="promoErr!=''" style="color:red;">invalid</div>
    </div>
    <div class="tablebox" style="text-align: right; background-color: #fff;">
          <el-button type="success" @click="payment" v-loading.fullscreen.lock="fullscreenLoading">Payment</el-button>
        </div>
      </div>

        </div>
  
      </div>
  
      <div class="container33 theme-showcase" v-if="(btmimg != '' && btmimg != null)">
        <img :src="btmimg" style="max-width: 100%; display:block; margin:0 auto;"  :style="BottomImgWidth==0?'width:100%;':('width:'+BottomImgWidth+'px;')" />
      </div>


      
  <el-dialog title="Edit" :visible.sync="dialogFormVisible" width="350px">
  <div>
    <div class="dialogInputLabel">First (Given) Name</div>
    <div>
      <el-input v-model="dname" @change="nameChange"></el-input>
    </div>
    <div class="dialogInputErr">
      {{ nameErr }}
    </div>
    <div class="dialogInputLabel">Last (Family) Name</div>
    <div>
      <el-input v-model="dlname" @change="lnameChange"></el-input>
    </div>
    <div class="dialogInputErr">
      {{ lnameErr }}
    </div>
    <div class="dialogInputLabel">Email</div>
    <div>
      <el-input v-model="demail" @change="emailChange"></el-input>
    </div>
    <div class="dialogInputErr">
      {{ emailErr }}
    </div>
    <div class="dialogInputLabel">Tel</div>
    <div>
      <el-input v-model="dtel" @change="telChange"></el-input>
    </div>
    <div class="dialogInputErr">
      {{ telErr }}
    </div>
  </div>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">Cancel</el-button>
    <el-button type="primary" @click="addSubmit">OK</el-button>
  </div>
</el-dialog>

    </div>
  </template>
  
  <script>
  import axios from 'axios'
import { loadStripe } from '@stripe/stripe-js';
  export default {
    name: 'homeheader',
    data: function () {
      return {
        promocode:'',
        promoErr:'',
        total:0,
      dialogFormVisible:false,
        tableData:[],
        meetingid:'',
        meetinglist:[],
        topimg: "",
        topimgWidth:0,
        BottomImgWidth:0,
        fieldlist: '',
        vallist: [],
        fieldval: [],
        fieldval2: [],
        fieldvalArr: [],
        imgsUrl: [],
        btmimg: '',
        checkList: [],
        btnDis: false,
        endtxt:'',
        FinishTxt:'',
        FinishHtml:'',
      FormWidth:0,
      FormMarginTop:0,
      FormMarginBtm:0,
      qrcodeurl:'',
      dname:'',
      demail:'',
      dtel:'',
      nameErr:'',
      lnameErr:'',
      dlname:'',
      emailErr:'',
      telErr:'',
      mbrArr:[],
      EarlyBird:'',
      promoAmount:0,
      fullscreenLoading:false,
      GstAmount:'',
      cateType:'',
      stripe:null,
      stripePublicKey: 'pk_test_51OlwZBG1y312NnZ4BxYiJvTKdYYRRN0SksDCVqM46KyF0lKjFty1wCbANvcxabG0Q0LNAYP275BY3BkNvYjAFlfO00jAXBnS5B'
      }
    },
    computed: {
    },
  created() {
    // 在组件创建时加载Stripe实例
    this.loadStripe();
  },
    methods: {
      
    async loadStripe() {
      // 加载Stripe实例
      this.stripe = await loadStripe(this.stripePublicKey);
    },

      applyPromo(){
var url = 'api/PromoCode/getPromoList?code=' + this.promocode +'&eventCode='+this.id;
        this.loading = true;
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        axios.post(url,
          {
          }
        )
          .then(this.applyPromoSucc)
      },
      applyPromoSucc(res){

        this.loading = false;
        res = res.data
        console.log(res);
        if (res && res.Code == 200) {
this.promoAmount = res.amount;
this.promoErr="";
        }else{
          this.promoAmount = 0;
          this.promoErr = "SHOW";
        }
      },

      rowClick(record,index){
        console.log(record);
        console.log(index);
        
        var index = this.tableData.indexOf(record);
        if(index==0) {return;}
        this.editIndex = index;
        console.log(this.editIndex);
var user= this.tableData[index];
this.dname = user.name;
this.dlname = user.lname;
this.demail=user.email;
this.dtel = user.tel;
this.dialogFormVisible=true;
      },
      handleDelete(index, rows){
this.dialogFormVisible=false;
            console.log(index);

            this.$confirm('This will permanently delete the data. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                var tableData=this.tableData;
                tableData.splice(index,1);
                this.jisuan();
            });
      },
      selectchange(){
this.jisuan();
      },
      jisuan(){
        var val = this.meetingid;
        var cateType= this.cateType;
        var meetinglist = this.meetinglist;
        var tableData = this.tableData;
        var list = [];
        for (var i = 0; i < val.length; i++) {
          for (var j = 0; j < meetinglist.length; j++) {
            if (val[i] == meetinglist[j].id) {
              list.push(meetinglist[j]);
            }
          }
        }
        console.log(list);
        var eb = false;
        const now = new Date();
        const targetTime = new Date(this.EarlyBird);
        if (now < targetTime) {
          eb = true;
        } else {
          eb = false;
        }
        var groupreg = false;
        if (tableData.length >= 4) {
          groupreg = true;
        }
        var total = 0;
        var mbrArr = this.mbrArr;
        for (var i = 0; i < tableData.length; i++) {
          var mbr = false;
          var page = 'Non-MBR';
          var amount = 0;
          var user = tableData[i];
          for (var j = 0; j < mbrArr.length; j++) {
            if (user['email'].toLowerCase().indexOf(mbrArr[j].toLowerCase()) > 0) {
              mbr = true;
              page = 'SEMI MBR';
            }
          }
          for (var k = 0; k < list.length; k++) {
            var item = list[k];
            if (eb) {
              if (cateType == "student") {
                amount = amount + item['ebirdStudent'];
              } else {
                if (mbr) {
                  amount = amount + item['ebirdMBR'];
                } else {
                  amount = amount + item['ebirdNonMBR'];
                }
              }
            } else {
              if (cateType == "student") {
                amount = amount + item['student'];
              } else {
                if (mbr) {
                  amount = amount + item['mbr'];
                } else {
                  amount = amount + item['nonmbr'];
                }
              }
            }
          if(groupreg){
            amount = Math.round((amount*(100-(item['groupDiscount']))/100) * 100) / 100;
          }
          }
          total=total+amount;
          console.log(amount);
          var user2 = {'name':user.name,'lname':user.lname,'email':user.email,'tel':user.tel,'package':page,'amount':amount};
          tableData[i] = user2;
          console.log(user2);
          console.log(tableData);
          this.$set(this.tableData, i, user2); 
        }
        this.GstAmount = Math.round((total*0.08) * 100) / 100;
        this.total=total;
   
      },
      payment(){
        this.fullscreenLoading=true;
console.log(this.meetingid);
var url = 'api/Meeting/postTranslog';
var amount =this.total-this.promoAmount +this.GstAmount;
        this.loading = true;
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        axios.post(url,
          {
            "no": this.no,
  "meetingids": this.meetingid,
  "userlist": this.tableData,
  "promocode": this.promocode,
  "eventid": this.id,
  "cateid": this.cate,
  "total": amount,
  "gst": this.GstAmount,
          }
        )
          .then(this.paymentSucc)
      },
      paymentSucc(res){

        this.loading = false;
        res = res.data
        console.log(res);
        if (res && res.Code == 200) {
this.handleCheckout(res.sessionid);
        } else if (res && res.Code == 335) {
          this.fullscreenLoading = false;
          this.$message.error(res.Msg+',already registered');
        } else {
          this.fullscreenLoading = false;
          this.$message.error(res.Msg);
        }
      },
      async handleCheckout(sessionid) {
    try {
      const { sessionId } = sessionid; // 通过服务器端创建结账会话
      const result = await this.stripe.redirectToCheckout({
        sessionId: sessionid
      });
      if (result.error) {
        console.error('重定向到结账页面时出错:', result.error);
      }
    } catch (error) {
      console.error('处理支付时出错:', error);
    }
  },

      addSubmit(){
        var err = false;
        if(this.dname==''){
this.nameErr="required";
err = true;
            }else{
                this.nameErr="";
            }
        if(this.dlname==''){
this.lnameErr="required";
err = true;
            }else{
                this.lnameErr="";
            }
            if(this.demail==''){
this.emailErr="required";
err = true;
            }else{
                this.emailErr="";
            }
            if(this.dtel==''){
this.telErr="required";
err = true;
            }else{
                this.telErr="";
            }
if(err){
  return;
}else{
  var tableData = this.tableData;
  var page='';
  var amount=0;
  var item = {'name':this.dname,'lname':this.dlname,'email':this.demail,'tel':this.dtel,'package':page,'amount':amount};
  console.log(this.editIndex);
  if(this.editIndex==-1){
    tableData.push(item);
  }else{
tableData.splice(this.editIndex,1,item);
  }
  this.tableData=tableData;
this.dialogFormVisible=false;
this.jisuan();
}
      },
      nameChange(val) {
        console.log(val);
        if (val != '' && val.length > 0) { this.nameErr = ''; }
        else {
          this.nameErr = "required";
        }
      },
      lnameChange(val) {
        console.log(val);
        if (val != '' && val.length > 0) { this.lnameErr = ''; }
        else {
          this.lnameErr = "required";
        }
      },
      emailChange(val) {
        console.log(val);
        if (val != '' && val.length > 0) { this.emailErr = ''; }
        else {
          this.emailErr = "required";
        }
      },
      telChange(val) {
        console.log(val);
        if (val != '' && val.length > 0) { this.telErr = ''; }
        else {
          this.telErr = "required";
        }
      },
      add(){
this.dialogFormVisible=true;
this.editIndex=-1;

this.dname = '';
this.dlname = '';
this.demail='';
this.dtel ='';
        },
        showRate(){

        },
      getImg(){
        // var userJson = JSON.parse(localStorage.getItem('userJson'));
        // axios.post('/api/Visitor/getQrcode?data='+ this.no +'&format=2048&w=300&h=300&m=1',
        //   {
        //     code: this.id
        //   }
        // )
        //   .then((res)=>{
        //     console.log(res);
        //     this.qrcodeurl = res.data;
            
        //   })
      },

      loadMeeting(){
        this.loading = true;
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        axios.post('/api/Meeting/getMeetingList?code='+this.id+'&cate='+this.cate,
          {
          }
        )
          .then(this.loadMeetingSucc)
      },
      loadMeetingSucc(res){

        this.loading = false;
        res = res.data
        console.log(res);
        if (res && res.Code == 200) {
this.meetinglist = res.list;
this.mbrArr = res.mbrArr;
this.EarlyBird=res.EarlyBird;
this.cateType = res.cateType;
this.loadEvent();
        }
      },
      loadEvent() {
        this.loading = true;
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        axios.post('/api/event/getOne?finish=2&code=' + this.id+'&no='+this.no,
          {
            code: this.id,
            finish:2,
            no:this.no
          }
        )
          .then(this.loadDataSucc)
      },
      loadDataSucc(res) {
        this.loading = false;
        res = res.data
        console.log(res);
        if (res && res.Code == 200) {
          var item = res;
          console.log(item);
          this.eventId = item.id;
            this.eventname = item.eventName;
            this.address = item.address;
            this.eventstartdate = item.beginDT;
            this.eventenddate = item.endDt;
            this.endtxt = item.endTxt;
            
          this.topimg = item.topimgUrl;
          this.topimgWidth = item.TopImgWidth;
          this.BottomImgWidth=item.BottomImgWidth,
      this.FormWidth=item.FormWidth;
      this.FormMarginTop=item.FormMarginTop;
      this.FormMarginBtm=item.FormMarginBtm;
          this.btmimg = item.bottomImgUrl;
          var userlist = item.userlist;
          var tableData = [];
          for(var i=0;i<userlist.length;i++){
            var user= userlist[i];
            tableData.push( {'name':user.FirstName,'lname':user.LastName,'email':user.Email,'tel':user.Tel,'package':'','amount':0});
          }
          this.tableData=tableData;
          this.meetingid = item.MeetingIds;
          // this.$nextTick();
          this.jisuan();
        } else {
          if (res && res.Code == 301) {
            localStorage.removeItem('userJson');
            this.$router.replace('/login');
          }
        }
      },
  
  
    },
    mounted() {
      const id = this.$route.query.id;
      const cate = this.$route.query.cate;
      const no = this.$route.query.no;
      this.id = id;
      this.cate = cate;
      this.no=no;
      this.getImg();
      
      this.loadMeeting();
    }
  }
  </script>
  <style lang="stylus" scoped>

.container33{
  margin:0 auto;
}
.container11{
  background:#fff;
  margin:auto;
  max-width:100%;
}

.selectbox{
    width: 96vw;
    max-width: 500px;
    margin:0 2vw;
}
.tablebox{
    margin:12px 2vw;
    background: #cce6ff;
    padding:2px 1px 1px 1px;
}
.dialogInputLabel{
  font-weight: bold;
  margin: 8px 0 4px 0;
}
.dialogInputErr{
  color:red; font-size:14px; margin-bottom:8px;
}
  </style>
  


// WEBPACK FOOTER //
// src/pages/home/payment.vue